import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import getXcolumnJson from "./xcolumn/list";
import ListSearchComponent from "./area/list_search";
import ListCardComponent from "../my_list/area/list_area";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import ViewCardComponent from "./area/view_area";
import strFunc from "@/lib/lyg/string";

function CorseList() {
  const xColumnArr = getXcolumnJson();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_state": "ing",
    "s_open_group": "",
    "s_textbook_in_now_period": "",
    "s_textbook_s_stu_mcomp_seq": "",
    "s_textbook_s_stu_seq": "",
    "s_addon_title_img": "1",
    "s_addon_section": "1",
    "s_addon_video": "1",
    "s_addon_use_stu": "1",
    "s_addon_use_stu_s_mcomp_seq": "",
    "s_addon_request": "1",
    "s_addon_request_s_mcomp_seq": "",
    "s_category_seq": "",
    "s_stu_seq": "",
  });
  let user = useSelector((state: any) => state.user);
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [categoryInfoArr, setCategoryInfoArr] = useState([]);
  const [viewSort, setViewSort] = useState("list");//list,view
  const ListSearchComponentRef = useRef<any>(null);
  const ListCardComponentRef = useRef<any>(null);
  const ViewCardComponentRef = useRef<any>(null);

  useEffect(() => {
    list({});
  }, [user.comp_seq]);

  useEffect(() => {
    list_category();
  }, []);

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj,
    };
    setListOpt(change_list_opt);
    if(change_list_opt.s_open_group=="main"){
      change_list_opt.s_mcomp_seq='';
      change_list_opt.s_textbook_in_now_period='1';
    }else{
      change_list_opt.s_mcomp_seq=user.comp_seq;
      change_list_opt.s_textbook_in_now_period='';
    }
    change_list_opt.s_textbook_s_stu_mcomp_seq = user.comp_seq;
    change_list_opt.s_textbook_s_stu_seq = user.user_seq;
    change_list_opt.s_addon_use_stu_s_mcomp_seq = user.comp_seq;
    change_list_opt.s_addon_request_s_mcomp_seq = user.comp_seq;

    if (strFunc.is_empty(change_list_opt.s_textbook_s_stu_mcomp_seq)) {
      return false;
    }
    if (strFunc.is_empty(change_list_opt.s_textbook_s_stu_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/corse/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListCardComponentRef.current) {
            ListCardComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const list_category = () => {
    let category_form_json = {
      "s_mcomp_seq": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/category/list', category_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setCategoryInfoArr(response.data["data"]["info_arr"]);
          if (ListSearchComponentRef.current) {
            ListSearchComponentRef.current.setCategoryInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  return (
    <CompLayout isConTitle={false}>
      <div className="stu_con_wrap">
        {viewSort == "list" &&
          <div>
            <ListSearchComponent
              ref={ListSearchComponentRef}
              categoryInfoArr={categoryInfoArr}
              listOpt={listOpt}
              list={(inOpt: any) => { list(inOpt); }}
            ></ListSearchComponent>
            <ListCardComponent
              ref={ListCardComponentRef}
              xColumnArr={xColumnArr}
              onClickRow={(inOptObj: any) => {
                setViewSort("view");
                setTimeout(() => {
                  if (ViewCardComponentRef.current) {
                    ViewCardComponentRef.current.set_row_data(inOptObj.data);
                  }
                }, 100);

              }}
            ></ListCardComponent>
            <Paging now_page={listOpt.now_page}
              num_per_page={listOpt.num_per_page}
              total_rec={countInfo.tot}
              onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
          </div>
        }
        {viewSort == "view" &&
          <ViewCardComponent
            ref={ViewCardComponentRef}
            xColumnArr={xColumnArr}
            onClose={() => {
              setViewSort("list");
              list({});
            }}
          ></ViewCardComponent>
        }
      </div>
    </CompLayout>
  );
}

export default CorseList;